// extracted by mini-css-extract-plugin
export default {"container":"src-components-RouteTabs-index-module__container__eqaqM","tabs":"src-components-RouteTabs-index-module__tabs__RSRgq"};